import React, {useState, useEffect, forwardRef, useImperativeHandle} from "react";
import { Col,  Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import ISIMSProviderConfig from "../../../models/misconfig/sims/SimsProviderConfig";
import IFormWithConfig from "../../../models/misconfig/FormWithConfig";

const SimsProviderConfigEdit = forwardRef((props: IFormWithConfig, ref) => {
    const [SIMsConfig, setSIMsConfig] = useState<ISIMSProviderConfig | null>(null);
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [errors, setErrors] = useState<{ [key: string]: string }>({});    

    useEffect(() => {
        if (props.configJson) {
            const configObj = JSON.parse(props.configJson) as ISIMSProviderConfig & {
                AttendanceWritebackEnabled?: boolean;
            };
            delete configObj.AttendanceWritebackEnabled;
            setSIMsConfig(configObj);
        } else {
            setSIMsConfig({
                SimsPath: '',
                Username: '',
                Password: '',
            });
        }
    }, [props.configJson]);

    useImperativeHandle(ref, () => ({
        validate: function() : boolean {
            const newErrors: { [key: string]: string } = {};
            
            if(!SIMsConfig?.SimsPath || SIMsConfig.SimsPath.trim() === '') {
                newErrors['SimsPath'] = 'SIMS Path is required';
            } else if(!windowsPathRegex.test(SIMsConfig?.SimsPath || '')) {
                newErrors['SimsPath'] = 'SIMS Path must be a valid Windows path';
            }

            if(!SIMsConfig?.Username || SIMsConfig.Username.trim() === '') {
                newErrors['Username'] = 'Username is required';
            }

            if(!SIMsConfig?.Password || SIMsConfig.Password.trim() === '') {
                newErrors['Password'] = 'Password is required';
            }

            setErrors(newErrors);
            return Object.keys(newErrors).length === 0;
        }
    }));

    const windowsPathRegex = /^[a-zA-Z]:\\(?:[^\\/:*?"<>|]+\\)*[^\\/:*?"<>|]*$/;

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleChange = (key: string, value: any) => {
        if(SIMsConfig === null) {
            return;
        }
        const updatedConfig = { ...SIMsConfig, [key]: value };
        setSIMsConfig(updatedConfig);
        props.setJsonString(JSON.stringify(updatedConfig));
    }

    return (
        <React.Fragment>
            <Row className="pb-3">
                <Col md={props.firstCol}>SIMS Path</Col>
                <Col md={props.secondCol}>
                    <input className={`form-control mt-1 ms-0 w-100 ${(errors.SimsPath) ? 'is-invalid' : ''}`} type="text" value={SIMsConfig?.SimsPath ?? ''} required
                        onChange={e => handleChange('SimsPath', e.target.value)} />  
                    {errors['SimsPath'] && <div className="invalid-feedback d-block">{errors['SimsPath']}</div>}
                </Col>
            </Row>
            <Row className="pb-3">
                <Col md={props.firstCol}>Username</Col>
                <Col md={props.secondCol}>
                    <input className={`form-control mt-1 ms-0 w-100 ${(errors.Username) ? 'is-invalid' : ''}`} type="text" value={SIMsConfig?.Username ?? ''} required
                        maxLength={50} onChange={e => handleChange('Username', e.target.value)} /> 
                    {errors['Username'] && <div className="invalid-feedback d-block">{errors['Username']}</div>}
                </Col>
            </Row>
            <Row className="pb-3">
                <Col md={props.firstCol}>Password</Col>
                <Col md={props.secondCol}>
                    <div className="password-input-container">
                        <input className={`form-control mt-1 ms-0 w-100 ${(errors.Password) ? 'is-invalid' : ''}`} type={showPassword ? 'text' : 'password'}
                            value={SIMsConfig?.Password ?? ''} required
                            onChange={e => handleChange('Password', e.target.value)} /> 
                        <button type="button" onClick={togglePasswordVisibility} className="password-toggle" >
                            {!errors.Password && (showPassword ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />)}
                        </button>
                    </div>
                    {errors.Password && <div className="invalid-feedback" style={{ display: 'block', color: '#DC3245' }}>{errors.Password}</div>}                   
                </Col>
            </Row>
        </React.Fragment>
    );
});

export default SimsProviderConfigEdit;